import { Button, FormSize } from "ui/ecosystems/forms";
import styled from "styled-components";

import { ExternalLink } from "ui/Link";

export function FacebookGroupConnectInstructions({
  className,
  ButtonProps,
}: {
  className?: string;
  ButtonProps: { disabled: boolean; onClick(): void };
}) {
  return (
    <Root className={className}>
      <p>
        To connect your Facebook Group, you need to first add the Sked Social
        'app' from the Facebook Group settings, then click the connect button in
        this window.
      </p>
      <Center>
        <img
          src="https://downloads.intercomcdn.com/i/o/264090848/cb2bb1e0fa25b0d2f06da86c/image.png"
          alt="Image of the Sked Social application in a Facebook Group. Use the link below to see how to add this to your Group."
        />
      </Center>
      <p>
        You can see{" "}
        <ExternalLink href="https://help.skedsocial.com/en/articles/4610111-adding-facebook-groups-to-sked-social-adding-the-application-to-the-group">
          how to add the Sked Social app to your Group(s) in this walkthrough
        </ExternalLink>
        .
      </p>
      <p>
        After adding the 'app' to your Group(s), click the button below to
        connect Sked and the Facebook Group(s).
      </p>
      <Center>
        <Button primary size={FormSize.large} {...ButtonProps}>
          It's installed - connect Facebook Group(s) now
        </Button>
      </Center>
    </Root>
  );
}

const Center = styled.div`
  display: flex;
  justify-content: center;
`;

const Root = styled.div`
  & > p {
    margin: 0;

    &:not(:first-of-type) {
      margin-top: 10px;
    }
  }

  & > ${Center} {
    margin: 12px 0;
  }
`;
